import { render, staticRenderFns } from "./IndicatorsEditor.vue?vue&type=template&id=56ce72c8"
import script from "./IndicatorsEditor.vue?vue&type=script&lang=js"
export * from "./IndicatorsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports